import type { SavedDashboard } from "../services/dashboard-service"

import { SettingsService } from "@/services/settings-service"

export function takeVisibleByPriority(
  maxCount: number,
  lists: {
    favorites: SavedDashboard[]
    company: SavedDashboard[]
    personal: SavedDashboard[]
  }
) {
  let remaining = maxCount
  const favorites = lists.favorites.slice(0, remaining)
  remaining -= favorites.length
  const company = lists.company.slice(0, remaining)
  remaining -= company.length
  const personal = lists.personal.slice(0, Math.max(0, remaining))
  return { favorites, company, personal }
}

const RECENTLY_VIEWED_KEY = "dashboards-recently-viewed"
const MAX_RECENT = 20

function getStorageScope(): string {
  const claims = SettingsService.getInstance().claims
  return `${claims.tid ?? "tenant"}:${claims.oid ?? "user"}`
}

export function getDashStorageKey(baseKey: string): string {
  return `${baseKey}:${getStorageScope()}`
}

export function getRecentlyViewedIds(): string[] {
  try {
    const stored = localStorage.getItem(getDashStorageKey(RECENTLY_VIEWED_KEY))
    return stored ? (JSON.parse(stored) as string[]) : []
  } catch {
    // localStorage may be unavailable (e.g. private browsing, storage quota)
    return []
  }
}

export function trackRecentlyViewed(dashboardId: string) {
  try {
    const ids = getRecentlyViewedIds().filter((id) => id !== dashboardId)
    ids.unshift(dashboardId)
    localStorage.setItem(
      getDashStorageKey(RECENTLY_VIEWED_KEY),
      JSON.stringify(ids.slice(0, MAX_RECENT))
    )
  } catch {
    // localStorage may be unavailable (e.g. private browsing, storage quota)
  }
}
